import config from '@/config';

export default function floatFilter(value) {
  return parseFloat(value).toLocaleString('ru-RU', {
    minimumFractionDigits: config.float.digits
  });
}
